import UserDriverListParams, {
  UserDriverListParamsOrder,
} from "../../../../../common/services/user/driver/list/user-driver-list-params";
import DriverListingFilter, {
  DriverListingActivityStatusFilter,
  DriverListingCandidatureActivityFilter,
  DriverListingDriverCreationDateFilter,
  DriverListingDriverModificationDateFilter,
  DriverListingFirstNameFilter,
  DriverListingFleetPartnerFilter,
  DriverListingLastNameFilter,
  DriverListingStartingAddressFilter,
  DriverListingTaxiCorporationFilter,
} from "./types/driver-listing-filter";
import DriverListingFilterType from "./types/driver-listing-filter-type";
import DriverListingSortKey from "./types/driver-listing-sort-key";

const createOrder = (
  sortKey: DriverListingSortKey | null,
): UserDriverListParamsOrder | undefined => {
  const definition: Record<DriverListingSortKey, UserDriverListParamsOrder> = {
    [DriverListingSortKey.FIRST_NAME_ASC]:
      UserDriverListParamsOrder.FIRST_NAME_ASC,
    [DriverListingSortKey.FIRST_NAME_DESC]:
      UserDriverListParamsOrder.FIRST_NAME_DESC,
    [DriverListingSortKey.LAST_NAME_ASC]:
      UserDriverListParamsOrder.LAST_NAME_ASC,
    [DriverListingSortKey.LAST_NAME_DESC]:
      UserDriverListParamsOrder.LAST_NAME_DESC,
    [DriverListingSortKey.TAXI_CORPORATION_ASC]:
      UserDriverListParamsOrder.TAXI_CORPORATION_DISPLAY_NAME_ASC,
    [DriverListingSortKey.TAXI_CORPORATION_DESC]:
      UserDriverListParamsOrder.TAXI_CORPORATION_DISPLAY_NAME_DESC,
    [DriverListingSortKey.LAST_PLAN_ENTRY_END_TIME_ASC]:
      UserDriverListParamsOrder.LAST_PLAN_ENTRY_END_TIME_ASC,
    [DriverListingSortKey.LAST_PLAN_ENTRY_END_TIME_DESC]:
      UserDriverListParamsOrder.LAST_PLAN_ENTRY_END_TIME_DESC,
    [DriverListingSortKey.CREATION_DATE_ASC]:
      UserDriverListParamsOrder.CREATION_DATE_ASC,
    [DriverListingSortKey.CREATION_DATE_DESC]:
      UserDriverListParamsOrder.CREATION_DATE_DESC,
    [DriverListingSortKey.MODIFICATION_DATE_ASC]:
      UserDriverListParamsOrder.MODIFICATION_DATE_ASC,
    [DriverListingSortKey.MODIFICATION_DATE_DESC]:
      UserDriverListParamsOrder.MODIFICATION_DATE_DESC,
  };

  return sortKey ? definition[sortKey] : undefined;
};

const create = (
  page: number,
  pageSize: number,
  filters: DriverListingFilter[],
  sortKey: DriverListingSortKey | null,
): UserDriverListParams => {
  const statusFilter = filters.find(
    (filter) => filter.type === DriverListingFilterType.ACTIVITY_STATUS,
  )?.value as DriverListingActivityStatusFilter["value"] | undefined;

  const creationDateFilter = filters.find(
    (filter) => filter.type === DriverListingFilterType.CREATION_DATE,
  )?.value as DriverListingDriverCreationDateFilter["value"] | undefined;

  const modificationDateFilter = filters.find(
    (filter) => filter.type === DriverListingFilterType.MODIFICATION_DATE,
  )?.value as DriverListingDriverModificationDateFilter["value"] | undefined;

  return {
    page,
    pageSize,
    creationDateFrom: creationDateFilter?.from,
    creationDateTo: creationDateFilter?.to,
    modificationDateFrom: modificationDateFilter?.from,
    modificationDateTo: modificationDateFilter?.to,
    firstName: filters.find(
      (filter) => filter.type === DriverListingFilterType.FIRST_NAME,
    )?.value as DriverListingFirstNameFilter["value"] | undefined,
    lastName: filters.find(
      (filter) => filter.type === DriverListingFilterType.LAST_NAME,
    )?.value as DriverListingLastNameFilter["value"] | undefined,
    fleetPartner: filters.find(
      (filter) => filter.type === DriverListingFilterType.FLEET_PARTNER,
    )?.value as DriverListingFleetPartnerFilter["value"] | undefined,
    address: filters.find(
      (filter) => filter.type === DriverListingFilterType.STARTING_ADDRESS,
    )?.value as DriverListingStartingAddressFilter["value"] | undefined,
    isCandidaturePending: filters.find(
      (filter) => filter.type === DriverListingFilterType.CANDIDATURE_ACTIVITY,
    )?.value as DriverListingCandidatureActivityFilter["value"] | undefined,
    order: createOrder(sortKey),
    status: statusFilter,
    taxiCorporation: filters.find(
      (filter) => filter.type === DriverListingFilterType.TAXI_CORPORATION,
    )?.value as DriverListingTaxiCorporationFilter["value"] | undefined,
  };
};

const driverListingLoadParamsFactory = {
  create,
};

export default driverListingLoadParamsFactory;
